import { createEvent } from 'effector';
import { type PayoutTraderOrder } from '~/entities/payout';
import { openTraderOrderModal } from './lib';

export const openTraderOrder = createEvent<PayoutTraderOrder>();
openTraderOrder.watch(openTraderOrderModal);
